module.exports = __webpack_public_path__ + "static/img/CESAR_CORDOVA.6936028.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/CESAR_CORDOVA.jpg
// module id = TGEO
// module chunks = 1